<!-- <div class="footer">
    <a class="side-nav-item" (click)="actions.toggleNav()">
        <i class="fa fa-bars"></i>
    </a>
</div> -->

<div class="footer brand" (click)="actions.toggleNav()">
    <div class='title' [class]="{'title-full':toggle}">

        <ng-container *ngIf="toggle; else untoggleTemplate">
            <img src="/images/workbuddy_full_logo.svg" style="width:150px;" alt="WorkBuddy Logo">
        </ng-container>
        <ng-template #untoggleTemplate>
            <img src="/images/WorkBuddy.svg" alt="WorkBuddy Logo">
        </ng-template>

        <div class="plan-name" [class]="{'plan-name-full':toggle}">{{plan}}</div>

    </div>
</div>


<div #actionArea class=" actions actions-module" (keydown.tab)="onPreventTabKey($event)" data-cy="actions-module" cdk-scrollable>

    <ng-template ngFor let-route [ngForOf]="config" let-i="index">
        <sidenav-item [route]="route"></sidenav-item>
    </ng-template>

</div>

<div class="footer hidden">
    <uploader-centre endpoint="https://jmsfiles.blob.core.windows.net" [tenantId]='state?.user?.tenantUrl' [token]="state?.token" [signingEndpoint]="signingEndpoint" [successEndpoint]="successEndpoint"></uploader-centre>
</div>

<div class="footer">

    <div class="nav-divider"></div>

    @if(settingRoute) {
        <sidenav-item [route]="settingRoute"></sidenav-item>
    }

    <help-nav [navExpanded]="toggle"></help-nav>
    <user-nav [accountUrl]="accountUrl" [state]="state" (logout)="onLogout()"></user-nav>


</div>

<div class="build-version">
    <span *ngIf="buildVersion && toggle">{{buildVersion}}</span>
</div>